<template>
  <div class="action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <el-form-item label="用户ID:" prop="toUserID">
          <el-input
            v-model.number="params.toUserID"
            size="small"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <el-input
            v-model="params.content"
            type="textarea"
            rows="3"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="图片:"
          prop="image"
          style="width: 480px"
        >
          <base-upload
            :cover="params.image"
            :action="uploadUrl"
            @successCallback="uploadImg"
            :width="'120px'"
            :height="'120px'"
            :hide="true"
          ></base-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="sendComment()"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      dialogVisible: false,
      title: "评论",
      // 提交状态
      flag: false,
      id: "",
      // 回复评论的参数
      params: {
        objID: "",
        cid: "",
        rid: "",
        level: 2,
        content: "",
        toUserID: undefined,
        image: "",
      },
      // 表单验证规则
      rules: {
        // toUserID: [
        //   { required: true, message: "请输入用户ID", trigger: "blur" },
        // ],
        content: [
          { required: true, message: "请输入评论内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 图上传成功
    uploadImg(res) {
      this.params.image = res.data.coverImg;
    },
    sendComment() {
      // if (!this.params.toUserID) return this.$message.error("用户ID不可为空");
      if (!this.params.content) return this.$message.error("评论内容不可为空");
      const params = Object.assign({}, this.params);
      API.replyComment(params)
        .then((res) => {
          (res.code === 200 &&
            (this.$message.success("评论成功！"),
            this.handleClose(),
            this.$emit("handleList"))) ||
            this.$message.error("操作失败，请重试");
        })
        .catch(() => {
          this.$message.error("操作失败，请重试");
        })
        .finally(() => {
          this.params.content = "";
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        objID: "",
        cid: "",
        rid: "",
        level: 2,
        content: "",
        image: "",
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.params = {
        objID: data.objID,
        cid: data.cid || "",
        rid: data.level == 2 ? data.rid : undefined,
        level: data.level || 2,
        content: "",
        image: "",
      };
    },
  },
};
</script>
